import { generateArcVertices, getEntityExtrusionTransform } from "./helpers";
export function decomposeCircle(entity, dxfHeaders) {
    return generateArcVertices({
        center: entity.center,
        radius: entity.radius,
        transform: getEntityExtrusionTransform(entity),
        dxfHeaders,
    });
}
//# sourceMappingURL=decomposeCircle.js.map